import { Controller } from "@hotwired/stimulus"

const DISMISSED_KEY = "lifPwaInstallDismissedAt"
const DISMISS_DAYS = 14

// De propósito SEM flag "já instalado" permanente no localStorage: isso
// nunca se apaga sozinho quando a pessoa desinstala o ícone da tela
// inicial (o navegador não avisa esse evento), então travaria o banner
// escondido pra sempre mesmo depois de desinstalar. Em vez disso, a cada
// carregamento da página a gente checa em tempo real se está rodando
// "standalone" (ou seja, aberto pelo ícone) — só isso já garante que quem
// tá de fato com o app instalado nunca vê o banner, e quem desinstalou (ou
// nunca instalou) volta a ver normalmente.
export default class extends Controller {
  static targets = [ "instructions", "installButton", "iosInstallButton", "iosSteps" ]
  static values = { androidText: String }

  connect() {
    if (this.isStandalone()) return
    if (this.recentlyDismissed()) return

    if (this.isIos()) {
      // Sem API de instalação automática no Safari — o botão "Instalar"
      // aqui só revela o passo a passo manual (ver showIosGuide).
      this.iosInstallButtonTarget.classList.remove("hidden")
      this.show()
    } else {
      // Não mostra nada até o navegador confirmar que o app é de fato
      // instalável (evento só dispara quando os critérios são atendidos)
      // — evita banner sem efeito em navegadores sem suporte.
      window.addEventListener("beforeinstallprompt", (event) => {
        event.preventDefault()
        this.deferredPrompt = event
        this.instructionsTarget.classList.remove("hidden")
        this.instructionsTarget.textContent = this.androidTextValue
        this.installButtonTarget.classList.remove("hidden")
        this.show()
      })
    }

    // Cobre o caso de a pessoa instalar por outro caminho que não o nosso
    // botão (ex: ícone de instalação da própria barra de endereço do
    // Chrome) — some com o banner na hora, sem precisar recarregar.
    window.addEventListener("appinstalled", () => this.hide())
  }

  async install() {
    if (!this.deferredPrompt) return

    this.deferredPrompt.prompt()
    await this.deferredPrompt.userChoice
    this.deferredPrompt = null
    this.hide()
  }

  showIosGuide() {
    this.iosStepsTarget.classList.remove("hidden")
    this.iosInstallButtonTarget.classList.add("hidden")
  }

  dismiss() {
    localStorage.setItem(DISMISSED_KEY, Date.now().toString())
    this.hide()
  }

  show() {
    this.element.classList.remove("hidden")
  }

  hide() {
    this.element.classList.add("hidden")
  }

  isStandalone() {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  }

  isIos() {
    return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream
  }

  recentlyDismissed() {
    const dismissedAt = localStorage.getItem(DISMISSED_KEY)
    if (!dismissedAt) return false

    const days = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24)
    return days < DISMISS_DAYS
  }
}
